import { BaseEntity } from "./BaseEntity";
import {computed} from "vue";

export class LayoutEntity extends BaseEntity {
    constructor() {
        super();

        this.entityName = "components.isp.layoutList.layout";
        this.pageTitle = "components.settings.permissionManagement.menuList.AttributesLayout";
        this.menuPath = "/isp";
        this.APIRoute = "Resources/ISP/Layout";
        this.i18nBase = "components.isp.layout";

        this.endpoints = {
            list: "/layout",
            create: "/layout",
            get: "/layout/:id",
            delete: "/layout/:id",
            activate: "/layout/:id/activate",
            deactivate: "/layout/:id/deactivate"
        };

        this.fields = [
            {
                key: "sequence",
                label: "components.isp.layout.sequence",
                type: "number",
                visible: true,
                required: true,
                editable: true,
                orderBy: true,
                maxlength: 30,
                cols:6
            },
            {
                key: "attribute",
                label: "components.isp.attributeList.attribute",
                type: "autocomplete",
                visible: true,
                required: true,
                editable: true,
                source: "attributeList",
                searchHandler: "handleSearchAttribute",
                options: [],
                cols:6
            },
            {
                key: "radiusOperatorListCheck",
                label: "components.isp.layout.radiusOperator",
                type: "select",
                visible: true,
                required: true,
                editable: false,
                source: "radiusOperatorList",
                options: [
                    { label: "==", value: "=="},
                    { label: "!=", value: "!="},
                    { label: ">", value: ">"},
                    { label: ">=", value: ">=" },
                    { label: "<" , value: "<" },
                    { label: "<=", value: "<=" },
                    { label: "=~", value: "=~" },
                    { label: "!~", value: "!~" },
                    { label: "=" , value: "=" },
                    { label: ":=", value: ":=" },
                    { label: "=*", value: "=*" },
                    { label: "!*", value: "!*" }
                ],
                cols:6
            },
            {
                key: "radiusOperatorListReply",
                label: "components.isp.layout.radiusOperator",
                type: "select",
                visible: true,
                required: true,
                editable: false,
                source: "radiusOperatorList",
                options: [
                    { label: "=", value:"="},
                    { label: ":=", value: ":="},
                    { label: "+=", value: "+="}
                ],
                cols:6
            },
            {
                key: "value",
                label: "components.isp.layout.value",
                type: "combobox",
                multiple: true,
                visible: true,
                required: true,
                editable: true,
                source: "varTemplatesList",
                itemTitle: "name",
                itemValue: "name",
                options: [],
                cols:6
            },
            {
                key: "clientaccessState",
                label: "components.isp.layout.category",
                type: "select",
                visible: true,
                required: false,
                editable: true,
                source: "clientStateList",
                options: [],
                itemTitle: "label",
                itemValue: "value",
                cols:6
            },
            {
                key: "connection_type",
                label: "components.isp.layout.connetionType",
                type: "radioButton",
                visible: true,
                required: true,
                editable: true,
                options: [
                    { label: "PPPoE", value: "PPPoE", default: true },
                ],
                cols:6
            }
        ]

        this.customActions = {
            duplicate: true,
        }

        this.tableColumns = [
            {
                key: "name",
                label: "common.labels.name",
                visible: true,
                orderBy: true
            },
            {
                key: "status",
                label: "common.labels.status",
                visible: true,
                orderBy: true
            },
            {
                key: "actions",
                label: "common.labels.actions",
                visible: true,
                orderBy: false
            },
        ]


        this.tableColumnsAttributes = [
            {
                key: "sequence",
                label: "components.isp.layout.sequence",
                visible: true,
                orderBy: false
            },
            {
                key: "name",
                label: "components.isp.layout.attribute",
                visible: true,
                orderBy: false
            },
            {
                key: "operator",
                label: "components.isp.layout.radiusOperator",
                visible: true,
                orderBy: false
            },
            {
                key: "clientaccessState",
                label: "components.isp.layout.category",
                visible: true,
                orderBy: false
            },
            {
                key: "value",
                label: "components.isp.layout.value",
                visible: true,
                maxChars: 20,
                orderBy: false
            },
            {
                key: "connection_type",
                label: "components.isp.layout.connetionType",
                visible: true,
                orderBy: false
            },            {
                key: "actions",
                label: "common.labels.actions",
                visible: true,
                orderBy: false
            },

        ]
        this.pages = {
            edit: {
                pageTitle: `${this.i18nBase}.pageTitleEdit`,
                pathI18n: `components.settings.permissionManagement.menuList.ISP/components.settings.permissionManagement.menuList.AttributesLayout`,
                route: ["/isp","/isp/layouts", "/isp/layout/edit/:id"]
            },
            create: {
                pageTitle: `${this.i18nBase}.pageTitle`,
                pathI18n: `components.settings.permissionManagement.menuList.ISP/components.settings.permissionManagement.menuList.AttributesLayout`,
                route: ["/isp","/isp/layouts", "/isp/layout/create"]
            },
            list: {
                pageTitle: `components.settings.permissionManagement.menuList.AttributesLayout`,
                pathI18n: `components.settings.permissionManagement.menuList.ISP`,
                route: ["/isp"],
                filters: {
                    quickSearch: {
                        info: "common.messages.info.searchByName",
                        searchBy: ["name"],
                        type: "text",
                    },
                    advanced: {
                        fields: [
                            {
                                key: "status",
                                label: "common.labels.status",
                                type: "select",
                                options: [
                                    { label: "common.labels.active", value: true },
                                    { label: "common.labels.inactive", value: false },
                                ],
                            }
                        ],
                    },
                },
            },
        };
    }

    getUrl(endpoint, params = {}) {
        let url = endpoint;
        Object.keys(params).forEach(key => {
            url = url.replace(`:${key}`, params[key]);
        });
        return url;
    }
}
